// Add to translations - dedicated pages
export const pageTranslations = {
  fr: {
    common: { backHome: 'Retour à l\'accueil', learnMore: 'En savoir plus', contactUs: 'Contactez-nous' },
    pages: {
      trading: {
        breadcrumb: 'Trading', hero: 'Trading de Matières Premières',
        sub: 'Un service complet pour les producteurs mondiaux de matières premières souhaitant accéder au marché chinois.',
        section1Title: 'Notre expertise', section1Body: 'Nous sommes des traders physiques spécialisés dans l\'achat, la sécurisation et la revente de grandes quantités de matières premières. Notre réseau d\'acheteurs chinois cherche constamment du volume qualifié.',
        section2Title: 'Matières traitées',
        section3Title: 'Comment ça fonctionne',
        steps: [
          { t: 'Soumettez votre offre', d: 'Remplissez le formulaire avec vos spécifications, quantités et conditions.' },
          { t: 'Analyse & pré-qualification', d: 'Notre équipe examine l\'offre et vous contacte sous 48h.' },
          { t: 'Négociation', d: 'Nous vous mettons en relation avec les acheteurs qualifiés.' },
          { t: 'Documentation & logistique', d: 'Contrats, inspection, douane et expédition — nous gérons tout.' },
          { t: 'Paiement sécurisé', d: 'Modalités convenues et libération des fonds à la livraison.' },
        ],
        ctaTitle: 'Producteur ? Déposez votre offre', ctaBody: 'Rejoignez notre réseau. Toutes les offres restent confidentielles.',
      },
      missions: {
        breadcrumb: 'Missions Commerciales', hero: 'Missions Commerciales en Chine',
        sub: 'Nous organisons pour vous des missions clés en main pour rencontrer les meilleurs manufacturiers chinois.',
        includes: 'Ce que comprend une mission',
        items: [
          'Agenda personnalisé selon votre secteur',
          'Interprète bilingue français/anglais/mandarin',
          'Visites d\'usines pré-qualifiées',
          'Réunions B2B avec décideurs',
          'Transport et hébergement organisés',
          'Rapport détaillé et suivi post-mission',
        ],
        upcoming: 'Prochaines missions programmées',
        ctaTitle: 'Envie de participer à une mission ?', ctaBody: 'Contactez-nous pour connaître les places disponibles et le programme détaillé.',
        exp: {
          badge: 'Notre expérience',
          title: 'Missions officielles avec les plus hauts dirigeants',
          body: 'Stephen Harper, Philippe Couillard, Denis Coderre, délégation des Cégeps du Québec, CANADA @ CIIE 2025… Découvrez en images les rencontres qui ont scellé nos partenariats sino-canadiens.',
          cta: 'Voir nos missions officielles',
        },
      },
      partners: {
        breadcrumb: 'Recherche de Partenaires', hero: 'Recherche de Partenaires Industriels',
        sub: 'Nous identifions et validons pour vous des partenaires ou manufacturiers chinois selon vos critères précis.',
        why: 'Pourquoi nous ?',
        whys: [
          'Réseau exclusif de manufacturiers pré-qualifiés',
          'Vérification légale et financière systématique',
          'Audit qualité et visite d\'usine sur place',
          'Négociation contrats et accompagnement long terme',
        ],
        process: 'Notre processus rigoureux',
        ctaTitle: 'Cherchez-vous un partenaire chinois ?', ctaBody: 'Décrivez votre besoin et nous vous présenterons une short-list qualifiée.',
      },
      rescued: {
        breadcrumb: 'Produits Rescapés', hero: 'Produits Rescapés à Prix Avantageux',
        sub: 'Marchandises retenues en douane, invendues ou non payées — disponibles pour distributeurs et consommateurs.',
        types: 'Types de lots disponibles',
        typesList: [
          { t: 'Marchandises douanières', d: 'Biens retenus par les autorités douanières et libérés à des prix négociés.' },
          { t: 'Invendus & surstocks', d: 'Produits neufs qui n\'ont pas trouvé preneur, disponibles en lots.' },
          { t: 'Non payés', d: 'Commandes refusées par le client final, mises sur le marché à prix cassés.' },
          { t: 'Faillites', d: 'Liquidations d\'entreprises avec inventaire complet.' },
        ],
        available: 'Lots actuellement disponibles',
        ctaTitle: 'Distributeur ou détaillant ?', ctaBody: 'Nous vous informons dès qu\'un nouveau lot correspond à vos critères.',
      },
      merchandise: {
        breadcrumb: 'Diverses Marchandises', hero: '16 Catégories de Marchandises',
        sub: 'Un catalogue diversifié sourcé directement chez nos manufacturiers partenaires chinois.',
        catalog: 'Notre catalogue',
        note: 'Volumes flexibles, import direct, support logistique complet.',
        ctaTitle: 'Besoin d\'un produit spécifique ?', ctaBody: 'Envoyez-nous votre demande et nous trouvons le manufacturier idéal.',
      },
      companies: {
        breadcrumb: 'Entreprises du Mois', hero: 'Entreprises Chinoises du Mois',
        sub: 'Chaque mois, deux entreprises chinoises soigneusement sélectionnées pour leur expertise et leur qualité.',
        featured: 'Sélection du mois',
        ctaTitle: 'Intéressé par une de ces entreprises ?', ctaBody: 'Nous facilitons la mise en relation et l\'échange d\'échantillons.',
      },
      experience: {
        breadcrumb: 'Expérience', hero: 'Une expérience diplomatique et industrielle éprouvée',
        sub: "Depuis plus d'une décennie, Jimmy Changtao Yu, co-fondateur de Yuville, accompagne les plus hautes institutions canadiennes et québécoises dans leurs échanges avec la Chine. Ces rencontres officielles illustrent la profondeur de son réseau et la confiance qu'il inspire des deux côtés du Pacifique.",
        intro1Title: 'Un pont vivant entre le Canada et la Chine',
        intro1Body: "Missions gouvernementales, cérémonies de signature, délégations éducatives et sportives : Jimmy Yu a été présent aux tables où se sont scellés bon nombre des rapprochements sino-canadiens des dix dernières années.",
        galleryTitle: 'Moments marquants',
        photos: [
          {
            title: 'Cérémonie de signature — CANADA @ CIIE 2025',
            place: 'Shanghai, Chine • 2025',
            caption: "Cérémonie de signature officielle au pavillon canadien de la China International Import Expo (CIIE), sous l'égide du Service des délégués commerciaux du Canada. Jimmy Yu (à droite) accompagnant les partenaires québécois et chinois.",
          },
          {
            title: 'Poignée de main avec le Très Honorable Stephen Harper',
            place: 'Cabinet du Premier Ministre du Canada',
            caption: "Rencontre officielle entre Jimmy Yu et le très honorable Stephen Harper, alors Premier Ministre du Canada, dans le cadre de l'Association Canada-Chine des Restaurateurs Chinois du Québec.",
          },
          {
            title: 'Cérémonie de signature — Équipements de puissance intelligents',
            place: 'Pékin, Chine',
            caption: "Cérémonie de signature d'un accord de coopération sino-canadien sur les équipements de puissance intelligents. Jimmy Yu (troisième à partir de la gauche) au sein de la délégation canadienne.",
          },
          {
            title: 'Délégation de la Fédération des Cégeps du Québec en Chine',
            place: 'Chine',
            caption: "Accueil officiel de la délégation de la Fédération des Cégeps du Québec par un partenaire universitaire chinois. Jimmy Yu a facilité l'organisation et l'accompagnement de cette mission éducative.",
          },
          {
            title: 'Mise au jeu protocolaire au Stade national de Pékin (Nid d\'Oiseau)',
            place: 'Pékin, Chine • Mission Québec-Chine',
            caption: "Mise au jeu de hockey réunissant Philippe Couillard (alors Premier Ministre du Québec), Denis Coderre (alors maire de Montréal) et Jimmy Yu (maillot Québec #10), au cœur du stade olympique de Pékin lors d'une mission économique du Québec en Chine.",
          },
        ],
        ctaTitle: 'Bénéficiez de ce réseau', ctaBody: "Notre expérience et nos contacts au plus haut niveau sont à votre service pour ouvrir les bonnes portes en Chine.",
      },
    },
  },
  en: {
    common: { backHome: 'Back to home', learnMore: 'Learn more', contactUs: 'Contact us' },
    pages: {
      trading: {
        breadcrumb: 'Trading', hero: 'Commodity Trading',
        sub: 'A complete service for global commodity producers looking to access the Chinese market.',
        section1Title: 'Our expertise', section1Body: 'We are physical traders specialized in buying, securing and reselling large quantities of raw materials. Our network of Chinese buyers is constantly looking for qualified volume.',
        section2Title: 'Commodities handled',
        section3Title: 'How it works',
        steps: [
          { t: 'Submit your offer', d: 'Fill in the form with your specifications, quantities and conditions.' },
          { t: 'Analysis & pre-qualification', d: 'Our team reviews the offer and contacts you within 48h.' },
          { t: 'Negotiation', d: 'We connect you with qualified buyers.' },
          { t: 'Documentation & logistics', d: 'Contracts, inspection, customs and shipping — we handle it all.' },
          { t: 'Secure payment', d: 'Agreed terms and release of funds on delivery.' },
        ],
        ctaTitle: 'Producer? Submit your offer', ctaBody: 'Join our network. All offers remain confidential.',
      },
      missions: {
        breadcrumb: 'Trade Missions', hero: 'Trade Missions to China',
        sub: 'We organize turnkey missions for you to meet the best Chinese manufacturers.',
        includes: 'What a mission includes',
        items: [
          'Custom agenda based on your sector',
          'Bilingual French/English/Mandarin interpreter',
          'Visits to pre-qualified factories',
          'B2B meetings with decision-makers',
          'Organized transport and accommodation',
          'Detailed report and post-mission follow-up',
        ],
        upcoming: 'Upcoming scheduled missions',
        ctaTitle: 'Want to join a mission?', ctaBody: 'Contact us for available spots and detailed program.',
        exp: {
          badge: 'Our track record',
          title: 'Official missions with top leaders',
          body: 'Stephen Harper, Philippe Couillard, Denis Coderre, the Québec CÉGEP Federation delegation, CANADA @ CIIE 2025… See in pictures the meetings that sealed our Sino-Canadian partnerships.',
          cta: 'See our official missions',
        },
      },
      partners: {
        breadcrumb: 'Partner Search', hero: 'Industrial Partner Search',
        sub: 'We identify and validate Chinese partners or manufacturers based on your precise criteria.',
        why: 'Why us?',
        whys: [
          'Exclusive network of pre-qualified manufacturers',
          'Systematic legal and financial verification',
          'On-site quality audit and factory visit',
          'Contract negotiation and long-term support',
        ],
        process: 'Our rigorous process',
        ctaTitle: 'Looking for a Chinese partner?', ctaBody: 'Describe your needs and we\'ll present a qualified short-list.',
      },
      rescued: {
        breadcrumb: 'Rescued Products', hero: 'Rescued Products at Attractive Prices',
        sub: 'Merchandise held at customs, unsold or unpaid — available for distributors and consumers.',
        types: 'Types of lots available',
        typesList: [
          { t: 'Customs merchandise', d: 'Goods held by customs authorities and released at negotiated prices.' },
          { t: 'Unsold & overstock', d: 'New products that didn\'t find buyers, available in lots.' },
          { t: 'Unpaid', d: 'Orders refused by the end client, put on the market at reduced prices.' },
          { t: 'Bankruptcies', d: 'Business liquidations with full inventory.' },
        ],
        available: 'Lots currently available',
        ctaTitle: 'Distributor or retailer?', ctaBody: 'We\'ll notify you when a new lot matches your criteria.',
      },
      merchandise: {
        breadcrumb: 'Various Merchandise', hero: '16 Merchandise Categories',
        sub: 'A diversified catalog sourced directly from our Chinese partner manufacturers.',
        catalog: 'Our catalog',
        note: 'Flexible volumes, direct import, full logistics support.',
        ctaTitle: 'Need a specific product?', ctaBody: 'Send us your request and we\'ll find the ideal manufacturer.',
      },
      companies: {
        breadcrumb: 'Companies of the Month', hero: 'Chinese Companies of the Month',
        sub: 'Every month, two Chinese companies carefully selected for their expertise and quality.',
        featured: 'Monthly selection',
        ctaTitle: 'Interested in one of these companies?', ctaBody: 'We facilitate introductions and sample exchange.',
      },
      experience: {
        breadcrumb: 'Experience', hero: 'A proven diplomatic and industrial track record',
        sub: 'For over a decade, Jimmy Changtao Yu, co-founder of Yuville, has supported Canada and Québec\'s highest institutions in their exchanges with China. These official meetings illustrate the depth of his network and the trust he inspires on both sides of the Pacific.',
        intro1Title: 'A living bridge between Canada and China',
        intro1Body: 'Government missions, signing ceremonies, educational and sports delegations: Jimmy Yu has been present at the tables where many of the Sino-Canadian partnerships of the past decade were sealed.',
        galleryTitle: 'Highlights',
        photos: [
          {
            title: 'Signing ceremony — CANADA @ CIIE 2025',
            place: 'Shanghai, China • 2025',
            caption: "Official signing ceremony at the Canadian pavilion of the China International Import Expo (CIIE), hosted by the Canadian Trade Commissioner Service. Jimmy Yu (right) alongside the Québec and Chinese partners.",
          },
          {
            title: 'Handshake with the Rt. Hon. Stephen Harper',
            place: 'Office of the Prime Minister of Canada',
            caption: 'Official meeting between Jimmy Yu and the Rt. Hon. Stephen Harper, then Prime Minister of Canada, on behalf of the Canada-China Association of Chinese Restaurateurs of Québec.',
          },
          {
            title: 'Signing ceremony — Smart power equipment',
            place: 'Beijing, China',
            caption: 'Signing ceremony of a Sino-Canadian cooperation agreement on intelligent power equipment. Jimmy Yu (third from the left) as part of the Canadian delegation.',
          },
          {
            title: 'Delegation of the Québec CÉGEP Federation to China',
            place: 'China',
            caption: 'Official welcome of the delegation of the Québec CÉGEP Federation by a Chinese university partner. Jimmy Yu facilitated the organization and stewardship of this educational mission.',
          },
          {
            title: 'Protocol face-off at the Beijing National Stadium (Bird\'s Nest)',
            place: 'Beijing, China • Québec–China mission',
            caption: "Hockey face-off with Philippe Couillard (then Premier of Québec), Denis Coderre (then Mayor of Montréal) and Jimmy Yu (Québec #10 jersey), inside Beijing's Olympic stadium during a Québec economic mission to China.",
          },
        ],
        ctaTitle: 'Leverage this network', ctaBody: 'Our experience and top-level contacts are at your service to open the right doors in China.',
      },
    },
  },
  zh: {
    common: { backHome: '返回首页', learnMore: '了解更多', contactUs: '联系我们' },
    pages: {
      trading: {
        breadcrumb: '贸易', hero: '大宗商品贸易',
        sub: '为希望进入中国市场的全球大宗商品生产商提供全套服务。',
        section1Title: '我们的专业', section1Body: '我们是专门从事大宗原材料采购、保障和转售的实体贸易商。我们的中国买家网络不断寻找合格的货量。',
        section2Title: '经手商品',
        section3Title: '运作方式',
        steps: [
          { t: '提交您的报价', d: '填写包含规格、数量和条件的表格。' },
          { t: '分析与预审', d: '我们的团队审核报价并在48小时内与您联系。' },
          { t: '谈判', d: '我们将您与合格的买家联系起来。' },
          { t: '文件与物流', d: '合同、检验、清关和运输——我们全权处理。' },
          { t: '安全付款', d: '约定条款并在交付时释放资金。' },
        ],
        ctaTitle: '生产商？提交报价', ctaBody: '加入我们的网络。所有报价均保密。',
      },
      missions: {
        breadcrumb: '商务考察', hero: '中国商务考察',
        sub: '我们为您组织一站式考察，以拜访最优秀的中国制造商。',
        includes: '考察内容',
        items: [
          '根据您的行业定制议程',
          '法语/英语/中文双语翻译',
          '参观预审过的工厂',
          '与决策者的 B2B 会议',
          '组织交通和住宿',
          '详细报告及考察后跟进',
        ],
        upcoming: '即将安排的考察',
        ctaTitle: '想参加考察？', ctaBody: '联系我们了解可用名额和详细行程。',
        exp: {
          badge: '我们的经验',
          title: '与最高层领导人的正式考察',
          body: '史蒂芬·哈珀、菲利普·库亚尔、丹尼斯·科德尔、魁北克 CÉGEP 大学院联盟代表团、CANADA @ CIIE 2025……以图片形式回顾那些成就我们中加合作的重要时刻。',
          cta: '查看我们的正式考察',
        },
      },
      partners: {
        breadcrumb: '寻找合作伙伴', hero: '工业合作伙伴搜索',
        sub: '我们根据您的精确标准，为您识别并验证中国合作伙伴或制造商。',
        why: '为什么选择我们？',
        whys: [
          '预审过的独家制造商网络',
          '系统的法律和财务验证',
          '现场质量审计和工厂参观',
          '合同谈判和长期支持',
        ],
        process: '我们严格的流程',
        ctaTitle: '寻找中国合作伙伴？', ctaBody: '描述您的需求，我们将提供合格的候选名单。',
      },
      rescued: {
        breadcrumb: '救援产品', hero: '优惠价格的救援产品',
        sub: '被海关扣留、未售出或未支付的商品——供分销商和消费者选购。',
        types: '可用批次类型',
        typesList: [
          { t: '海关商品', d: '由海关当局扣留并以议价释放的货物。' },
          { t: '滞销与库存过剩', d: '未找到买家的全新产品，成批出售。' },
          { t: '未付款', d: '被最终客户拒收的订单，以降价投放市场。' },
          { t: '破产', d: '完整清算的企业库存。' },
        ],
        available: '当前可用批次',
        ctaTitle: '您是分销商或零售商？', ctaBody: '当新批次符合您的标准时，我们会通知您。',
      },
      merchandise: {
        breadcrumb: '各类商品', hero: '16 类商品',
        sub: '直接从我们的中国合作制造商采购的多元化目录。',
        catalog: '我们的目录',
        note: '灵活数量、直接进口、全面物流支持。',
        ctaTitle: '需要特定产品？', ctaBody: '发送您的请求，我们将找到理想的制造商。',
      },
      companies: {
        breadcrumb: '本月企业', hero: '本月中国企业',
        sub: '每月精选两家因其专业和品质而入选的中国企业。',
        featured: '本月精选',
        ctaTitle: '对其中一家企业感兴趣？', ctaBody: '我们协助引荐和样品交换。',
      },
      experience: {
        breadcrumb: '经验', hero: '深厚的外交与工业经验',
        sub: '十多年来，Yuville 联合创始人余长涛 (Jimmy Changtao Yu) 一直协助加拿大及魁北克最高级别的机构与中国开展交流。这些正式合影展示了他人脉的深度以及他在中加两地所赢得的信任。',
        intro1Title: '连接加拿大与中国的桥梁',
        intro1Body: '政府考察、签约仪式、教育及体育代表团 —— 过去十年间众多中加合作的关键时刻，余长涛都亲临见证。',
        galleryTitle: '重要时刻',
        photos: [
          {
            title: '签约仪式 —— CANADA @ CIIE 2025',
            place: '中国上海 • 2025 年',
            caption: '在中国国际进口博览会（CIIE）加拿大馆举行的正式签约仪式，由加拿大贸易专员署主办。Jimmy Yu（右）与魁北克及中方合作伙伴出席。',
          },
          {
            title: '与加拿大前总理史蒂芬·哈珀阁下会晤',
            place: '加拿大总理办公室',
            caption: 'Jimmy Yu 代表魁北克华人餐饮业加中协会，与时任加拿大总理史蒂芬·哈珀 (Stephen Harper) 阁下的正式会晤。',
          },
          {
            title: '签约仪式 —— 智能电力装备',
            place: '中国北京',
            caption: '中加智能电力装备合作协议签约仪式。Jimmy Yu（左起第三位）作为加拿大代表团成员出席。',
          },
          {
            title: '魁北克 CÉGEP 大学院联盟代表团访华',
            place: '中国',
            caption: '中方大学合作伙伴正式接待魁北克 CÉGEP 大学院联盟代表团。Jimmy Yu 协助组织并全程陪同此次教育考察。',
          },
          {
            title: '北京国家体育场（鸟巢）礼仪开球',
            place: '中国北京 • 魁北克—中国经贸考察',
            caption: '时任魁北克省长菲利普·库亚尔 (Philippe Couillard)、时任蒙特利尔市长丹尼斯·科德尔 (Denis Coderre) 与身着魁北克 10 号球衣的 Jimmy Yu 一起，于北京奥运主场馆内进行冰球开球仪式，作为魁北克经贸考察团的重要活动。',
          },
        ],
        ctaTitle: '善用这一人脉网络', ctaBody: '我们的经验与高层人脉可为您在中国打开正确的大门。',
      },
    },
  },
};
